import { resumeReducer } from './reducer';
import { initialResumeState } from './state';

const RESUME_MODULE_NAME = 'resume';

export { RESUME_MODULE_NAME, initialResumeState, resumeReducer };
